import { Component, OnInit } from '@angular/core';
import { RestService } from '../../service/rest.service';
import { LoaderService } from '../../service/loader.service';
import { Message } from '../../service/message.service';
import { SeoService } from '../../service/seo.service';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styles: [],
  standalone: false
})
export class ContactsComponent implements OnInit {

  constructor(private rest: RestService, private loader: LoaderService, private message: Message, private seo: SeoService) { }

  contactForm = {
    name: '',
    email: '',
    subject: '',
    company: '',
    message: ''
  }

  myFormData = new FormData() 

  ngOnInit(): void {
    this.seo.updateSeo({
      titleSeo: "Contatti Innovation Plaza | Richiedi Consulenza",
      metadescription: 'Contatta Innovation Plaza per supporto su bandi, innovazione e finanza agevolata. Il nostro team ti risponderà rapidamente.',
      url: 'https://innovationplaza.it/contatti',
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "ContactPage",
          "@id": "https://innovationplaza.it/contatti/#webpage",
          "url": "https://innovationplaza.it/contatti/",
          "name": "Contatta Innovation Plaza",
          "description": "Contattaci per una consulenza su innovazione aziendale, fondi europei, bandi e sviluppo imprenditoriale. Risposta entro 24 ore lavorative.",
          "inLanguage": "it-IT",
          "isPartOf": { "@id": "https://innovationplaza.it/#website" },
          "about": { "@id": "https://innovationplaza.it/#organization" },
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://innovationplaza.it/" },
              { "@type": "ListItem", "position": 2, "name": "Contatti", "item": "https://innovationplaza.it/contatti/" }
            ]
          },
          "mainEntity": {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "email": "info@innovationplaza.it",
            "telephone": "+39-02-49539510",
            "availableLanguage": [
              { "@type": "Language", "name": "Italian" },
              { "@type": "Language", "name": "English" }
            ],
            "hoursAvailable": {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "09:00",
              "closes": "18:00"
            }
          }
        },
        {
          "@context": "https://schema.org",
          "@type": "ProfessionalService",
          "@id": "https://innovationplaza.it/#localbusiness-milano",
          "name": "Innovation Plaza Sede Nord Italia (Milano)",
          "image": "https://innovationplaza.it/assets/og-image.jpg",
          "telephone": "+39-02-49539510",
          "email": "info@innovationplaza.it",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Viale Papiniano, 44",
            "addressLocality": "Milano",
            "addressRegion": "MI",
            "postalCode": "20123",
            "addressCountry": "IT"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 45.4625,
            "longitude": 9.1710
          },
          "openingHoursSpecification": [{
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "09:00",
            "closes": "18:00"
          }],
          "parentOrganization": {
            "@id": "https://innovationplaza.it/#organization"
          }
        },
        {
          "@context": "https://schema.org",
          "@type": "ProfessionalService",
          "@id": "https://innovationplaza.it/#localbusiness-brindisi",
          "name": "Innovation Plaza Sede Centro-Sud Italia (Brindisi)",
          "image": "https://innovationplaza.it/assets/og-image.jpg",
          "url": "https://innovationplaza.it",
          "email": "info@innovationplaza.it",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Brindisi",
            "addressRegion": "BR",
            "addressCountry": "IT"
          },
          "openingHoursSpecification": [{
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "09:00",
            "closes": "18:00"
          }],
          "parentOrganization": {
            "@id": "https://innovationplaza.it/#organization"
          }
        }
      ]
    });
  }

  openInput(){
    let input = document.getElementById('upload-cv')
    input?.click()
  }

  changeInput(event:any){
    if(event.target.files[0]){
      this.loader.on()
      this.myFormData.append('file',event.target.files[0])
      this.rest.post('/user/curriculum',this.myFormData).subscribe({
        next:(value)=> {
          this.loader.off(false)
          this.message.showMessage('Curriculum caricato con successo','success')
        },
        error:(value)=> {
          this.loader.off(false)
          this.message.showMessage('Errore nel caricamento del file','error')
        },
      })
    }
  }

  sendEmail() {
    let params = {
      name: this.contactForm.name + ' - ' + this.contactForm.company,
      subject: this.contactForm.subject,
      email: this.contactForm.email,
      message: this.contactForm.message
    }
    this.loader.on()
    this.rest.post('/user/contattaci', params).subscribe({
      next: (value) => {
        this.loader.off(true)
        this.message.showMessage('Email inviata', 'success')
        this.contactForm = {
          name: '',
          email: '',
          subject: '',
          company: '',
          message: ''
        }
      },
      error: (value) => {
        this.loader.off(true)
        this.message.showMessage("Errore nell'invio email", 'error')
        this.contactForm = {
          name: '',
          email: '',
          subject: '',
          company: '',
          message: ''
        }
      },
    })
  }
}
